export const DEFAULT_INVENTORY_PUSH_MINIMUM_QUANTITY = 2;

export interface InventoryPushSettings {
  inventoryPushMinimumQuantity?: number | null;
}

export function getInventoryPushMinimumQuantity(
  settings: InventoryPushSettings | null | undefined,
): number {
  const minimumQuantity = settings?.inventoryPushMinimumQuantity;
  if (
    minimumQuantity == null ||
    !Number.isFinite(minimumQuantity) ||
    minimumQuantity < 0
  ) {
    return DEFAULT_INVENTORY_PUSH_MINIMUM_QUANTITY;
  }
  return Math.floor(minimumQuantity);
}

export function getInventoryPushQuantity({
  sourceQuantity,
  settings,
}: {
  sourceQuantity: bigint | number;
  settings: InventoryPushSettings | null | undefined;
}): number {
  const quantity = Math.max(0, Number(sourceQuantity));
  const minimumQuantity = getInventoryPushMinimumQuantity(settings);
  return quantity >= minimumQuantity ? quantity : 0;
}

/**
 * Sellable managed-3PL `on_hand` for one row: buffer applied after
 * max(0, quantity - reserved). `committed` is not subtracted (Shopify does that).
 */
export function getSellableInventoryPushQuantity({
  quantity,
  reserved,
  settings,
}: {
  quantity: bigint | number;
  reserved: bigint | number;
  settings: InventoryPushSettings | null | undefined;
}): number {
  const sellableQuantity = Math.max(0, Number(quantity) - Number(reserved));
  return getInventoryPushQuantity({
    sourceQuantity: sellableQuantity,
    settings,
  });
}

export function shouldPushAdditiveInventoryRestock({
  sourceQuantity,
  settings,
}: {
  sourceQuantity: bigint | number;
  settings: InventoryPushSettings | null | undefined;
}): boolean {
  const quantity = Math.max(0, Number(sourceQuantity));
  const minimumQuantity = getInventoryPushMinimumQuantity(settings);
  return quantity >= minimumQuantity;
}
